<template>
  <b-container class="my-3">
    <b-row>
      <b-col cols="12">
        <h1 class="display-4 text-purple">Preguntas frecuentes</h1>
        <div role="tablist">
          <b-card no-body class="mb-1">
            <b-card-header header-tag="header" class="p-1" role="tab">
              <b-button block v-b-toggle.question-1 variant="white" class="text-left">¿Qué métodos de pago utilizan?</b-button>
            </b-card-header>
            <b-collapse id="question-1" visible accordion="accordion" role="tabpanel">
              <b-card-body>
                <b-card-text>Aceptamos pagos con tarjeta (débito y crédito), depósitos en Oxxo y transferencia bancaria vía CoDi.</b-card-text>
              </b-card-body>
            </b-collapse>
          </b-card>

          <b-card no-body class="mb-1">
            <b-card-header header-tag="header" class="p-1" role="tab">
              <b-button block v-b-toggle.question-2 variant="white" class="text-left">¿Cuales son los métodos de envio disponibles?</b-button>
            </b-card-header>
            <b-collapse id="question-2" accordion="accordion" role="tabpanel">
              <b-card-body>
                <b-card-text>
                  Manejamos envíos a toda la república mexicana por RedPack y Fedex dependiendo la disponibilidad de tu código postal.
                  <ul>
                    <li>Envío económico de 4 a 7 días hábiles - $130.00</li>
                    <li>Envío exprés 2 a 3 días hábiles - $180.00</li>
                  </ul>
                  <small>*Aplican restricciones/No aplica en zonas extendidas</small><br />
                  <small>*Seguro incluído en todos los envíos</small>
              </b-card-text>
              </b-card-body>
            </b-collapse>
          </b-card>

          <b-card no-body class="mb-1">
            <b-card-header header-tag="header" class="p-1" role="tab">
              <b-button block v-b-toggle.question-3 variant="white" class="text-left">¿Cuanto tiempo tardan en enviar mi pedido?</b-button>
            </b-card-header>
            <b-collapse id="question-3" accordion="accordion" role="tabpanel">
              <b-card-body>
                <b-card-text>Todas nuestras piezas se elaboran cuidando todos los detalles para garantizar la satisfacción de nuestros clientes, si tenemos tu compra para envío inmediato la enviamos al siguiente día hábil después de reflejado el pago; de no tener la pieza para envío inmediato se envía 2 días hábiles después de reflejado el pago.</b-card-text>
              </b-card-body>
            </b-collapse>
          </b-card>

          <b-card no-body class="mb-1">
            <b-card-header header-tag="header" class="p-1" role="tab">
              <b-button block v-b-toggle.question-4 variant="white" class="text-left">¿Qué medidas de cuidado debo tener con mi joyería?</b-button>
            </b-card-header>
            <b-collapse id="question-4" accordion="accordion" role="tabpanel">
              <b-card-body>
                <b-card-text>
                Las piezas de joyería deben tener un cuidado especial que se describen a continuación:
                <ul>
                  <li>Debe tenerse el cuidado de aplicarse cremas, perfumes y otros productos de belleza antes de ponerse sus accesorios.</li>
                  <li>Evitar el contacto con agua u otros químicos abrasivos.</li>
                  <li>No use su joyería al realizar deportes o actividades dentro del hogar.</li>
                  <li>Deberán guardarse en su empaque original para evitar que choquen con otras piezas y pierdan su brillo.</li>
                </ul>
                </b-card-text>
              </b-card-body>
            </b-collapse>
          </b-card>

          <b-card no-body class="mb-1">
            <b-card-header header-tag="header" class="p-1" role="tab">
              <b-button block v-b-toggle.question-5 variant="white" class="text-left">¿Cómo puedo limpiar mi joyería?</b-button>
            </b-card-header>
            <b-collapse id="question-5" accordion="accordion" role="tabpanel">
              <b-card-body>
                <b-card-text>
                  <p>Si las joyas entran en contacto con agua se deben secar perfectamente con un paño suave que no deje residuos de pelusa.</p>
                  <p>Si entran en contacto con químicos abrasivos, se deben lavar con jabón neutro, enjuagar con abundante agua y secar perfectamente con un paño suave que no deje residuos de pelusa.</p>
                  <p>Posteriormente deben ser guardados en su empaque original.</p>
                </b-card-text>
              </b-card-body>
            </b-collapse>
          </b-card>

          <b-card no-body class="mb-1">
            <b-card-header header-tag="header" class="p-1" role="tab">
              <b-button block v-b-toggle.question-6 variant="white" class="text-left">¿Es posible personalizar mis accesorios?</b-button>
            </b-card-header>
            <b-collapse id="question-6" accordion="accordion" role="tabpanel">
              <b-card-body>
                <b-card-text>¡Por supuesto! Si deseas algún diseño especial o personalizado, por favor llena la información en el apartado de "Contacto" y nos pondremos en contacto lo más pronto posible.</b-card-text>
              </b-card-body>
            </b-collapse>
          </b-card>

          <b-card no-body class="mb-1">
            <b-card-header header-tag="header" class="p-1" role="tab">
              <b-button block v-b-toggle.question-7 variant="white" class="text-left">¿Manejan precios de mayoreo?</b-button>
            </b-card-header>
            <b-collapse id="question-7" accordion="accordion" role="tabpanel">
              <b-card-body>
                <b-card-text>
                  Manejamos un descuento sobre el precio final de compra a partir del siguiente número de piezas:
                  <ul>
                    <li>5% de descuento a partir de 6 piezas</li>
                    <li>10% de descuento a partir de 11 piezas</li>
                    <li>15% de descuento a partir de 16 piezas</li>
                  </ul>
                </b-card-text>
              </b-card-body>
            </b-collapse>
          </b-card>

          <b-card no-body class="mb-1">
            <b-card-header header-tag="header" class="p-1" role="tab">
              <b-button block v-b-toggle.question-8 variant="white" class="text-left">Quiero vender sus productos. ¿Cómo puedo volverme distribuidor de la marca?</b-button>
            </b-card-header>
            <b-collapse id="question-8" accordion="accordion" role="tabpanel">
              <b-card-body>
                <b-card-text>
                  Ya sea que desees ser distribuidor de la marca o iniciar tu negocio con joyería artesanal armada, llena la información en el apartado de "Contacto" y nos pondremos en contacto lo más pronto posible para platicar un poco más las necesidades que tienes.
                </b-card-text>
              </b-card-body>
            </b-collapse>
          </b-card>

          <b-card no-body class="mb-1">
            <b-card-header header-tag="header" class="p-1" role="tab">
              <b-button block v-b-toggle.question-9 variant="white" class="text-left">¿Emiten factura?</b-button>
            </b-card-header>
            <b-collapse id="question-9" accordion="accordion" role="tabpanel">
              <b-card-body>
                <b-card-text>
                  ¡Si emitimos factura! Si deseas que emitamos una factura por tu compra, contáctanos por medio del formulario de contacto indicando tu número de orden de compra y datos fiscales.
                </b-card-text>
              </b-card-body>
            </b-collapse>
          </b-card>

          <b-card no-body class="mb-1">
            <b-card-header header-tag="header" class="p-1" role="tab">
              <b-button block v-b-toggle.question-10 variant="white" class="text-left">Quiero obtener el descuento del 5% en mi siguiente compra</b-button>
            </b-card-header>
            <b-collapse id="question-10" accordion="accordion" role="tabpanel">
              <b-card-body>
                <b-card-text>
                  Lo único que tienes que hacer es recomendarnos en nuestras redes sociales.<br />
                  <small> *No es acumulable con otros descuentos ni cupones de descuento</small>
                </b-card-text>
              </b-card-body>
            </b-collapse>
          </b-card>
        </div>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
export default {
  name: 'Faq',
  data () {
    return {}
  }
}
</script>
